import { render } from "./Lookbooks.vue?vue&type=template&id=70e4bbf9"
import script from "./Lookbooks.vue?vue&type=script&lang=js"
export * from "./Lookbooks.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__